import React from 'react';
import '../buybox.scss';

const BuyboxError = () => {
  return (
    <div className="alert-inline alert-inline--warning buybox__error">
      <span>
        {'we\'re sorry, something went wrong on our end. Please try '}
        <button
          type="button"
          onClick={() => window.location.reload(false)}
          className="u__default-link"
        >
          refreshing.
        </button>
      </span>
    </div>
  );
};

BuyboxError.propTypes = {};

BuyboxError.defaultProps = {};

export { BuyboxError };
